export default "/images/945c8f8c84236527ee6db67662f31525.avif";